module.exports = __webpack_public_path__ + "img/862667370603267_image.jpg";